import {getConfig} from '../../services/config/configService';

const getUwmConfig = () => getConfig()?.uwmConfig;

const getUwmModule = (feature) => getUwmConfig()?.find((item) => item.feature === feature);

const getUwmModuleName = (feature) => getUwmModule(feature)?.uwm;

const getIsUwmEntryEnabled = (feature) =>
    Boolean(getUwmModuleName(feature)) && Boolean(getConfig()?.settings?.[feature]);

const configUwmGetters = {
    getUwmConfig,
    getUwmModule,
    getUwmModuleName,
    getIsUwmEntryEnabled,
};

export default configUwmGetters;
